/**
 * Copyright 2019, OpenCensus Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Cast `window` to be access the `ocLt` field for long task timings.  */
var windowWithLongTasks = window;
/** Returns the recorded performance entries but does not clear them. */
export function getPerfEntries() {
    if (!window.performance) {
        return {
            resourceTimings: [],
            longTaskTimings: [],
            paintTimings: [],
        };
    }
    var perf = window.performance;
    var longTaskTimings = windowWithLongTasks.ocLt;
    var entries = {
        resourceTimings: perf.getEntriesByType('resource'),
        paintTimings: perf.getEntriesByType('paint'),
        longTaskTimings: longTaskTimings ? longTaskTimings.slice() : [],
    };
    var navEntries = perf.getEntriesByType('navigation');
    if (navEntries.length) {
        entries.navigationTiming = navEntries[0];
    }
    return entries;
}
/** Clears resource timings, marks, measures and stored long task timings. */
export function clearPerfEntries() {
    if (!window.performance)
        return;
    windowWithLongTasks.ocLt = [];
    performance.clearResourceTimings();
    performance.clearMarks();
    performance.clearMeasures();
}
//# sourceMappingURL=perf-grouper.js.map